export class BaseApiError extends Error {
  public status: number
  constructor(statusCode: number, message: string) {
    super(message)
    Object.setPrototypeOf(this, BaseApiError.prototype)
    this.name = this.constructor.name
    if (typeof Error.captureStackTrace === 'function') {
      Error.captureStackTrace(this, this.constructor)
    } else {
      this.stack = new Error(message).stack
    }
    this.status = statusCode
  }
}

export class BadRequestError extends BaseApiError {
  constructor(message: string) {
    super(400, message)
    Object.setPrototypeOf(this, BadRequestError.prototype)
  }
}

export class UnauthorizedError extends BaseApiError {
  constructor(message: string) {
    super(401, message)
    Object.setPrototypeOf(this, UnauthorizedError.prototype)
  }
}

export class ServerError extends BaseApiError {
  constructor(message = 'Something went wrong') {
    super(500, message)
    Object.setPrototypeOf(this, ServerError.prototype)
  }
}

export default function ApiErrorFactory(status: number, message: string): BaseApiError {
  switch (status) {
    case 400:
      return new BadRequestError(message)
    case 401:
      return new UnauthorizedError(message)
    default:
      return new ServerError(message)
  }
}
